import { API_URLS } from "../configs/api.urls";
import { axiosPrivate } from "../configs/axios";

export const getStatistics = async () => {
  return await axiosPrivate({
    url: API_URLS.GET_STATISTICS_URL,
    method: "GET",
  });
};
